module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAYCAYAAACbU/80AAAABHNCSVQICAgIfAhkiAAAAR5JREFUSEu1lQERwjAMRakCcMChABwADnCABMABDpgEJCABB4CDScBB+R9aDsa2JlzSu17vsrT/LVt+w8BoxBhPOGqOuQwhXKXHBmliKQ8Ad+QMMbmKISwBZhA+ayHMAFghVEENYQrwD4Q5gBbCBUAD4QYghXAFkEA8AfD3jrjCQNjD76GNd3lFX3cEPNxi4yFt3gGiSlCquMCoWluUADU2j9MBNQAmCUAVLwF8fI5Lyn05JgDo29MUvAGApPwsqrgQ4Ii8ddbCuiAABVlujipfJNp4CQDn/Yrjn3PvglTNVnE+cwfoevNcMVeAkrhrBSTibgBScRcAjbg5gFbcFADitPDNl8k07pY2rzDrAgBErbh1BVa0Vsx981btc8kHKD3UU9IHqtgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow.png
// module id = 3Uj3
// module chunks = 1